import {lshGETAUTH} from './core';
import {graphqlRequestHandler} from './core';
import {
  ICompletedSupportForm,
  IFarmer,
  IFarmerAddressInput,
  IFarmerSignUpInput,
  IGenericResponse,
  IProduce,
  ISupportCustomer,
  ISupportMessage,
  IUser,
} from 'constants/interfaces';

export async function apiSearchFarmers(
  searchQuery: string,
  limit = 10,
): Promise<IFarmer[]> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {
      searchQuery: searchQuery,
      limit: limit,
    };
    return new Promise((resolve, reject) => {
      const query = `
          query variables($searchQuery: String!, $limit: Int){
              farmersBySearchQuery(searchQuery: $searchQuery, limit: $limit){
                  id
                  name
                  surname
                  email
                  phone
                  image
                  address
                  userId
                  farm{
                      id
                      name
                      sizeHectares
                      type
                      turnover
                      numberOfEmployees
                      fields{
                        info{
                            hectares
                            produce{
                              id
                              name
                            }
                          }
                      }
                      province
                      fields{
                            soilData{
                            soilType
                            P
                            K
                            Ca
                            Mg
                            Na
                            pH
                            cations
                            anions
                            exchangeableAcidity
                          }
                           id
                           coordinates{
                            lat
                            lng
                          }
                          risks{
                            analysisDate
                            ndviRiskLevel
                            moistureRiskLevel
                            clRiskLevel
                            averageRainFall
                            maxTemperature
                            minTemperature
                          }
                        info{
                          hectares
                          fieldName
                          variety
                          plantPopulation
                          irrigation
                          expectedYield
                          produce{
                            id
                            name
                          }
                        }
                  }


                        farmPolygons{




                      soilData{
                        soilType
                        P
                        K
                        Ca
                        Mg
                        Na
                        pH
                        cations
                        anions
                        exchangeableAcidity

                      }
                    }
                  }
                }
            }`;
      graphqlRequestHandler('farmersBySearchQuery', query, variables, headers)
        .then((farmers: IFarmer[]) => {
          return resolve(farmers);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiFarmerCreate(
  input: IFarmerSignUpInput,
): Promise<IGenericResponse> {
  return lshGETAUTH().then(() => {
    const headers = {};
    const variables = {input};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($input: signUpInput!){
                signUp(input: $input) {
                    success
                    message
                }
            }`;
      graphqlRequestHandler('signUp', query, variables, headers)
        .then((response: IGenericResponse) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiFarmerInvite(
  emails: string[],
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {emails};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($emails: [String!]!){
              supplierFarmerInvitation(emails: $emails) {
                message
                success
              }
          }`;
      graphqlRequestHandler(
        'supplierFarmerInvitation',
        query,
        variables,
        headers,
      )
        .then((response: IGenericResponse) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiGetFarmer(email: string): Promise<IFarmer> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {email};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($email: String){
              farmerByEmail(email: $email) {
                  id
                  name
                  surname
                  email
                  phone
                  image
                  address
                  userId
                  farm{


                  fields{
                            soilData{
                            soilType
                            P
                            K
                            Ca
                            Mg
                            Na
                            pH
                            cations
                            anions
                            exchangeableAcidity
                          }
                           id
                           coordinates{
                            lat
                            lng
                          }
                          risks{
                            analysisDate
                            ndviRiskLevel
                            moistureRiskLevel
                            clRiskLevel
                            averageRainFall
                            maxTemperature
                            minTemperature
                          }
                        info{
                          hectares
                          fieldName
                          variety
                          plantPopulation
                          irrigation
                          expectedYield
                          produce{
                            id
                            name
                          }
                        }
                  }

                      id
                      name
                      sizeHectares
                      type
                      turnover
                      numberOfEmployees
                      province
                        farmPolygons{

                      soilData{
                        soilType
                        P
                        K
                        Ca
                        Mg
                        Na
                        pH
                        cations
                        anions
                        exchangeableAcidity

                      }
                    }
                  }
              }
            }`;
      graphqlRequestHandler('farmerByEmail', query, variables, headers)
        .then((response: IFarmer) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiFarmerExists(email: string): Promise<IFarmer> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {email};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($email: String){
              farmerByEmail(email: $email) {
                  id
                  name
                  surname
                  email
                  phone
                  image
                  address
                  userId
                  farm{
                    id
                    name
                  }
              }
            }`;
      graphqlRequestHandler('farmerByEmail', query, variables, headers)
        .then((response: IFarmer) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiUpdateFarmerAddress(
  farmerId: number | string,
  addressInput: IFarmerAddressInput,
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {farmerId, addressInput};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($farmerId: ID, $addressInput: FarmerAddressInput!){
              farmerUpdateAddress(farmerId: $farmerId, addressInput: $addressInput) {
                  success
                  message
              }
            }`;
      graphqlRequestHandler('farmerUpdateAddress', query, variables, headers)
        .then((response: IGenericResponse) => resolve(response))
        .catch((error) => reject(error));
    });
  });
}

export async function apiGetSupportCustomers(): Promise<ISupportCustomer[]> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {};
    return new Promise((resolve, reject) => {
      const query = `
          query {
            supplierGetLinkedCustomers{
              farmerAccepted
              lastMessage{
                id
                from{
                  id
                  name
                  surname
                  image
                }
                to{
                  id
                  name
                  surname
                  image
                }
                type
                message
                insertedOn
              }
              farmer{
                id
                name
                surname
                email
                phone
                image
                address
                userId
                farm{
                    id
                    name
                    sizeHectares
                    type
                    turnover
                    numberOfEmployees
                    province
                    latLong
                }
              }
            }
          }`;
      graphqlRequestHandler(
        'supplierGetLinkedCustomers',
        query,
        variables,
        headers,
      )
        .then((customers: ISupportCustomer[]) => {
          customers.forEach((customer) => {
            if (!customer.lastMessage) return;
            customer.lastMessage.date = new Date(
              // @ts-ignore
              parseInt(customer.lastMessage.insertedOn),
            );
          });
          resolve(customers);
        })
        .catch((error) => reject(error));
    });
  });
}

export async function apiMoveSupportCustomer(
  farmerId: string,
  newSupplierId: string,
): Promise<void> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {farmerId, newSupplierId};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($farmerId: ID!, $newSupplierId: ID!){
            farmInputSupplierMoveCustomer(farmerId: $farmerId, newSupplierId: $newSupplierId){
              success
              message
            }
          }`;
      graphqlRequestHandler(
        'farmInputSupplierMoveCustomer',
        query,
        variables,
        headers,
      )
        .then((response: IGenericResponse) => {
          if (response.success) resolve();
          else reject(response.message);
        })
        .catch((error) => reject(error));
    });
  });
}

export async function apiGetSupportForms(
  farmerId: string,
): Promise<ICompletedSupportForm[]> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {farmerId};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($farmerId: ID!){
            getSupplierFarmerFormChat(farmerId: $farmerId){
              id
              from{
                id
              }
              to{
                id
              }
              type
              message
              insertedOn
            }
          }`;
      graphqlRequestHandler(
        'getSupplierFarmerFormChat',
        query,
        variables,
        headers,
      )
        .then((response: any) => {
          const forms: ICompletedSupportForm[] = response.map((form: any) => {
            const messages: ISupportMessage[] = form.map((message: any) =>
              mapSupportMessageResponse(message),
            );
            return messages;
          });
          resolve(forms);
        })
        .catch((error) => reject(error));
    });
  });
}

export async function apiGetSupportMessages(
  myUserId: string,
  customerUserId: string,
  limit?: number,
  desc?: boolean,
): Promise<ISupportMessage[]> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {userId: customerUserId, limit, desc};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($userId: ID!, $limit: Int, $desc: Boolean){
            getSupplierMessages(userId: $userId, limit: $limit, desc: $desc){
              id
              from{
                id
              }
              to{
                id
              }
              type
              message
              insertedOn
            }
          }`;
      graphqlRequestHandler('getSupplierMessages', query, variables, headers)
        .then((response: any) => {
          const messages: ISupportMessage[] = response.map((message: any) =>
            mapSupportMessageResponse(message),
          );
          resolve(messages);
        })
        .catch((error) => reject(error));
    });
  });
}

const mapSupportMessageResponse = (
  response: any,
): ISupportMessage & {farmer: IFarmer} => {
  return {
    ...response,
    ...response?.lastMessage,
    date: new Date(
      parseInt(response?.lastMessage?.insertedOn ?? response?.insertedOn),
    ),
  };
};

export async function apiSendSupportMessage(
  customerUserId: string,
  message: string,
  type: 'TEXT' | 'IMAGE',
): Promise<IGenericResponse> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {input: {id: customerUserId, type, message}};
    return new Promise((resolve, reject) => {
      const query = `
          mutation variables($input: SupplierFarmerChatInput){
            sendSupplierMessage(input: $input){
              id
            }
          }`;
      graphqlRequestHandler('sendSupplierMessage', query, variables, headers)
        .then(() => resolve({success: true}))
        .catch((error) => reject(error));
    });
  });
}

export async function apiGetNearestDepots(
  latitude: string,
  longitude: string,
): Promise<any[]> {
  return lshGETAUTH().then((data) => {
    const headers = {
      Authorization: data,
    };
    const variables = {latitude, longitude};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($latitude:String,$longitude:String){
              getDeports(latitude:$latitude,longitude:$longitude) {
                  id
                  deportId
                  name
                  address1
                  address2
                  address3
                  address4
                  address5
                  latitude
                  longitude
              }
          }`;
      graphqlRequestHandler('getDeports', query, variables, headers)
        .then((depots: any[]) => {
          return resolve(depots);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}

export async function apiGetUser(userId: string): Promise<IUser> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {userId};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($userId: ID){
            user(userId: $userId){
              id
              name
              surname
              email
              phone
              address
              latLong
              image
              farmer{
                id
                name
                surname
                email
                phone
                image
                address
                totalTraded
                farm{
                    id
                    name
                    sizeHectares
                    type
                    turnover
                    numberOfEmployees
                    province
                    latLong
                  fields{
                    id
                     coordinates{
                      lat
                      lng
                    }
                    availableLayers{
                      date
                      layers{
                        layer
                        url
                      }
                    }
  availableDroneLayers{
                      createdAt
                      analysisDate
                      rootLayerPathLink
                    }

                    risks{
                      analysisDate
                      ndviRiskLevel
                      moistureRiskLevel
                      clRiskLevel
                      averageRainFall
                      maxTemperature
                      minTemperature
                    }
                    info{
                      hectares
                      fieldName
                      variety
                      plantedOn
                      plantPopulation
                      irrigation
                      expectedYield
                      plantingDate
                      plannedPlantingDate
                      rowSpacingCm
                      seedSpacingCm
                      plantingDepthCm
                      harvestStartDate
                      harvestEndDate
                      produce{
                        id
                        name
                      }
                    }
                  }
                     farmPolygons{
                    coordinates{
                      lat
                      lng
                    }
                  }
                }
              }
            }
          }`;
      graphqlRequestHandler('user', query, variables, headers)
        .then((user: IUser) => resolve(user))
        .catch((error) => reject(error));
    });
  });
}

export async function apiGetProduce(
  ids?: (number | string)[],
): Promise<IProduce[]> {
  return lshGETAUTH().then((data) => {
    const headers = {Authorization: data};
    const variables = {produceIds: ids};
    return new Promise((resolve, reject) => {
      const query = `
          query variables($produceIds: [ID]){
            getAllProduce(produceIds: $produceIds){
              id
              name
              variety{
                id
                name
              }
            }
          }`;
      graphqlRequestHandler('getAllProduce', query, variables, headers)
        .then((allProduce: IProduce[]) => resolve(allProduce))
        .catch((error) => reject(error));
    });
  });
}

export async function apiUpdateInputsUser(
  userId: string | number,
  fields: {name?: string; surname?: string; phone?: string},
): Promise<void> {
  const data = await lshGETAUTH();
  const headers = {Authorization: data};
  const variables = {externalUserId: Number(userId), ...fields};
  return new Promise((resolve, reject) => {
    const query = `
        mutation variables($externalUserId: Int!, $name: String, $surname: String, $phone: String) {
          updateInputsUserByExternalId(externalUserId: $externalUserId, name: $name, surname: $surname, phone: $phone) {
            id
          }
        }`;
    graphqlRequestHandler(
      'updateInputsUserByExternalId',
      query,
      variables,
      headers,
    )
      .then(() => resolve())
      .catch(reject);
  });
}

export async function apiUpdateInputsFarm(
  userId: string | number,
  fields: {
    farmName?: string;
    province?: string;
    address?: string;
    ownedHectares?: number;
  },
): Promise<void> {
  const data = await lshGETAUTH();
  const headers = {Authorization: data};
  const variables = {externalUserId: Number(userId), ...fields};
  return new Promise((resolve, reject) => {
    const query = `
        mutation variables(
          $externalUserId: Int!, $farmName: String, $province: String,
          $address: String, $ownedHectares: Float
        ) {
          updateInputsFarmByExternalUserId(
            externalUserId: $externalUserId, farmName: $farmName,
            province: $province, address: $address, ownedHectares: $ownedHectares
          ) {
            id
          }
        }`;
    graphqlRequestHandler(
      'updateInputsFarmByExternalUserId',
      query,
      variables,
      headers,
    )
      .then(() => resolve())
      .catch(reject);
  });
}

export async function apiUpdateInputsCompany(
  userId: string | number,
  fields: {
    name?: string;
    location?: string;
    vatNumber?: string;
    taxNumber?: string;
  },
): Promise<void> {
  const data = await lshGETAUTH();
  const headers = {Authorization: data};
  const variables = {externalUserId: Number(userId), ...fields};
  return new Promise((resolve, reject) => {
    const query = `
        mutation variables(
          $externalUserId: Int!, $name: String, $location: String,
          $vatNumber: String, $taxNumber: String
        ) {
          updateInputsCompanyByExternalUserId(
            externalUserId: $externalUserId, name: $name, location: $location,
            vatNumber: $vatNumber, taxNumber: $taxNumber
          ) {
            id
          }
        }`;
    graphqlRequestHandler(
      'updateInputsCompanyByExternalUserId',
      query,
      variables,
      headers,
    )
      .then(() => resolve())
      .catch(reject);
  });
}
